<script lang="ts">
    import { spaLink } from "../../actions"

    export let jobEntry: ContentEntry
</script>

{#if jobEntry}
    <a use:spaLink href="{jobEntry.path}" class="btn-full-width"> {jobEntry.job?.title || ""} </a>
{/if}
